import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'

const HidePasswordToggle = ({
  isVisible,
  toggle,
}: {
  isVisible: boolean
  toggle: () => void
}) => {
  return (
    <button
      onClick={(e) => {
        e.stopPropagation()
        e.preventDefault()
        toggle()
      }}
      type="button"
      tabIndex={-1}
    >
      {isVisible ? (
        <AiOutlineEye size="2em" />
      ) : (
        <AiOutlineEyeInvisible size="2em" />
      )}
    </button>
  )
}

export default HidePasswordToggle
